import { Children, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import StarIconClosed from 'packages/kakapo-ui-kit/assets/icons/StarIconClosed';
import StarIconOpen from 'packages/kakapo-ui-kit/assets/icons/StarIconOpen';

const Container = styled(Box)<{ last?: boolean }>`
	${(props) => !props.last && `border-bottom: 1px solid ${props.theme.colors.lightBlue};`}
`;

const Title = styled(Box)`
	flex-grow: 1;
	flex-shrink: 1;
	color: ${(props) => props.theme.colors.lightBlueDark};
`;

const Empty = styled(Box)`
	text-align: center;
	color: ${(props) => props.theme.colors.lightBlueDark};
`;

const Rating = styled(Flex)`
	svg {
		display: block;
	}
`;

function Star(props: { filled: boolean }) {
	return <Box ml={1}>{props.filled ? <StarIconClosed /> : <StarIconOpen />}</Box>;
}

export function RatingMetricItem(props: { title: string; value: number }) {
	return (
		<Flex p={3} alignItems="center">
			<Title>{props.title}</Title>
			<Rating>
				<Star filled={props.value > 0} />
				<Star filled={props.value > 1} />
				<Star filled={props.value > 2} />
				<Star filled={props.value > 3} />
				<Star filled={props.value > 4} />
			</Rating>
		</Flex>
	);
}

export default function RatingMetric(props: PropsWithChildren<{}>) {
	const { t } = useTranslation();

	return (
		<>
			{Children.count(props.children) === 0 && (
				<Empty p={3}>{t('dashboard.metrics.ranking.empty')}</Empty>
			)}
			{Children.map(props.children, (child, index) => (
				<Container last={index === Children.count(props.children) - 1}>{child}</Container>
			))}
		</>
	);
}
